/**
 * Pie Adblock - A Powerful Free Ad Blocker
 *
 * Blocker whose page-world shims (suppressAlert, suppressConfirm) are exposed to every origin — unusual for a blocker, most hide these.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker, so detection falls back to resource probing.
 * Manifest verified against version 1.33.8.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'jpkfgepcmmchgfbjblnodjhldacghenp';
export const pieAdblock: ExtensionDefinition = {
  id: ID,
  name: "Pie Adblock - A Powerful Free Ad Blocker",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 2000000,
  notes: "Blocker whose page-world shims (suppressAlert, suppressConfirm) are exposed to every origin — unusual for a blocker, most hide these.",
  signals: [
    { id: 'war-assets-page-suppressalert-js', kind: 'web-accessible-resource',
      description: 'Fetch assets/page/suppressAlert.js, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'assets/page/suppressAlert.js') },
    { id: 'war-assets-page-suppressconfirm-js', kind: 'web-accessible-resource',
      description: 'Fetch assets/page/suppressConfirm.js, exposed to every origin.',
      weight: 0.5, run: () => probeFetch(ID, 'assets/page/suppressConfirm.js') },
  ],
};
